import { defineComponent as _defineComponent } from 'vue'

import { ReplyDto } from "@/apiRequests/models/communityTalk/replyGetResponse";
import ReplyMaster from "@/components/communityTalk/reply/ReplyMaster.vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";

interface Props {
	/**
	 * リプライ情報群。
	 */
	replies: ReplyDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    replies: { type: Array, required: true },
    wordSettings: { type: null, required: true },
    communityTalkStoreKey: { type: String, required: true },
    replyPostStoreKey: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * リプライ情報群。
	 */
	replies: ReplyDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}
/**
 * リプライ一覧。
 */



const __returned__ = { props, ReplyMaster }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})